import axiosInstance from "@/lib/axiosInstance";
import type { CustomAxiosRequestConfig } from "@/types/common.types";
import { userManagementEndpoints } from "./userManagement.endpoints";

/** `true` taken, `false` free, `null` unknown: an unknown answer must not block anyone. */
export type EmailInUseAnswer = boolean | null;

export type EmailInUseClient = {
  isEmailInUse: (email: string, signal?: AbortSignal) => Promise<EmailInUseAnswer>;
};

type EmailInUseResponse = { data?: { inUse?: unknown } | null };

/**
 * `GET /user-management/users/email-in-use?email=` (SERV-3545): in use anywhere on the platform or
 * not, and never who has it. A refusal (a 403 for someone without the create switch), a failure or
 * an answer of the wrong shape is "unknown", so the create call's own 409 stays the backstop.
 */
export const emailInUseClient: EmailInUseClient = {
  isEmailInUse: async (email, signal) => {
    try {
      const { data } = await axiosInstance.get<EmailInUseResponse>(
        userManagementEndpoints.emailInUse,
        { params: { email }, signal, suppressErrorAlert: true } as CustomAxiosRequestConfig,
      );
      const inUse = data?.data?.inUse;
      return typeof inUse === "boolean" ? inUse : null;
    } catch {
      return null;
    }
  },
};
